import Swiper from 'swiper';

const swiperStrategy = new Swiper(document.querySelector('.strategy__slider-container'), {
    slidesPerView: 'auto',
    spaceBetween: 19,
    navigation: {
        nextEl: '.strategy__button-next',
        prevEl: '.strategy__button-prev',
    },
    breakpoints: {
        // when window width is >= 320px
        // when window width is >= 640px
        769: {
            spaceBetween: 24
        }
    }
});